import React, { useEffect, useState, useContext } from "react";
import { getTokens } from "./Utilities/tokenUtility";
import { HiXMark } from "react-icons/hi2";
import { AuthContext } from "./Utilities/AuthContext";
import { revokeSession } from "./App";// Assuming this function exists to handle logout
import { FaCheckCircle, FaRegCircle } from "react-icons/fa"
import { v4 as uuidv4 } from 'uuid';


const SettingsPopup = ({ showSettings, setShowSettings, }) => {


        const [profileName, setProfileName] = useState("");
        const [usersTokens, setUsersTokens] = useState([]);
        const { setIsLoggedIn } = useContext(AuthContext);

        const availableTokens = [
            { name: "DealCompass CRM", provider: "DealCompass", srcImage: "/assets/DealCompass_Initials_BlueLetters_TransparentBg_clipped_rev_1.png" },
            { name: "Google", provider: "google", srcImage: "/assets/google-calendar-icon.png" },
            { name: "Microsoft", provider: "graph", srcImage: "/assets/outlook_calendar.png" },
            { name: "Dotloop", provider: "dotloop", srcImage: "/assets/dotloopFullLogo.png" },
            { name: "Trello", provider: "trello", srcImage: "/assets/trello.svg" },
        ]

        useEffect(()=>{
            if (showSettings) {
                getTokens().then((res) => {
                    setProfileName(res.session.ClientName || "No profile found");
                    setUsersTokens(res.tokens || []);
                })
            } 
        }, [showSettings])

        if (!showSettings) return null;

        return (
            <>
                <div style={{position: "fixed", top: "0", right: "0", width: "100vw", height: "100vh", background: "rgba(0,0,0,0.1)", zIndex: 20000}}
                onClick={()=>{setShowSettings(false)}}></div>
                <div style={{position: "fixed", top: "calc(50vh - 225px)", right: "calc(50vw - 150px)", width: "300px", height: "450px", background: "white", zIndex: 20002,
                     borderRadius: "5px", boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", gap: "20px", padding: "20px", paddingTop: "35px"}}>
                        
                            <div style={{display: "flex", padding: "3px", justifyContent: "center", alignItems: "center", cursor: "pointer",
                                position: "absolute", top: "10px", right: "10px"
                            }} onClick={()=>{setShowSettings(false)}}>
                                <HiXMark />
                            </div>

                        <h2 style={{margin: "0px", textAlign: "center", fontSize: "20px", whiteSpace: "prewrap", textWrap: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%"}}>{profileName}</h2>
                        <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center" ,gap: "10px", padding: "0px 10px"}}>
                        <p>Connected accounts</p>

                        {availableTokens.map((token, index) => {

                            const isTokenConnected = usersTokens.find(t => t.Provider === token.provider) || token.provider === "DealCompass"
                        
                           return ( <div key={index} style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 10px", border: "1px solid rgb(209,209,209)", borderRadius: "3px", cursor: "pointer",
                            minHeight: "40px"
                           }}
                            role="button"
                            onClick={()=>{
                                // if (isTokenConnected) {
                                    // alert(`You are already connected to ${token.name}.`);
                                    // handleRevokeToken(token.provider);
                                    
                                    // return;
                                // } else {
                                        handleAuthenticate(token.provider);
                                    // alert(`${token.name} not enabled yet.`)
                                // }
                            }}>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                                <div style={{display: "flex", flexDirection: "row", gap: "5px", alignItems: "center"}}>
                                    <div style={{width: "40px", height: "20px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <img src={token.srcImage} alt="" style={{width: "auto", height: "20px"}}></img>
                                    </div>
                                    <span style={{fontSize: "14px", fontWeight: "bold"}}>{token.name}</span>
                                </div>

                                {isTokenConnected ? <FaCheckCircle style={{color:"rgb(19, 239, 125)"}} /> : <FaRegCircle style={{color:"rgb(109,109,109)"}}/>}

                                </div>
                                </div>
                        )
                    })
                } 
                </div>
                            


                        <div style={{padding: "5px 10px", cursor: "pointer", border: "1px solid rgb(209,209,209)", borderRadius: "3px"}}
                        onClick={()=>{
                            revokeSession(setIsLoggedIn);
                            setShowSettings(false);
                        }}>Log out</div>

                
                </div>
            </>
        );
}

export default SettingsPopup;



export const handleRevokeToken = async (tokenID, triggerLoadAlert, triggerFailAlert, triggerSuccessAlert, getProfileData) => {
    try {

        triggerLoadAlert(`Logging out...`);
        const response = await fetch('https://functionappfordev.azurewebsites.net/api/tokenCrud?method=REVOKE_TOKEN', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-UserSessionID': localStorage.getItem('UserSessionID') || ''
            },
            body: JSON.stringify({ TokenID: tokenID }),
        });
        if (!response.ok) {
            throw new Error('Failed to revoke token');
        }
        const data = await response.json();
        console.log('Token revoked successfully:', data);
        triggerSuccessAlert('Logged out successfully.');
        getProfileData()
    } catch (error) {
        console.error('Error revoking token:', error);
        triggerFailAlert(`Failed to log out. Please try again later.`);
    }
};

export const handleAuthenticate = async (api, optionalScope) => {



 // ✅ 1. Generate random state
    const tokenState = uuidv4(); // ← THIS replaces your old "tokenName"
    console.log("Generated token state:", tokenState);
    


    // ✅ 2. Save the state to your backend
    try {
      const saveStateResponse = await fetch('https://functionappfordev.azurewebsites.net/api/saveOAuthState', {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'X-UserSessionID': localStorage.getItem('UserSessionID') || ''
        },
        body: JSON.stringify({ 
            state: tokenState,
            metadata: {
                redirectUri: window.location.href.includes('localhost') ? 'http://localhost:3001' : 'https://chat.dealcompass.co',
                browser: navigator.userAgent,
                // googleVerify: optionalScope ? true : false,
            }
        }),
      });


      if (!saveStateResponse.ok) {
        throw new Error('Failed to save OAuth state');
      }

      await saveStateResponse.json();

    } catch (error) {
      console.error('Error saving OAuth state:', error);
        alert('Error initiating OAuth process. Please try again later.', error.message);
      return;
    }



// setRecentMessages(messages.slice(-10))


switch(api) {
    case "dotloop":
        // alert('Dotloop integration is currently in beta! Please contact us at matt@dealcompass.co to get early access.');
        // window.open(`https://functionappfordev.azurewebsites.net/api/dotloopAuthHandler?action=authCode&state=${tokenState}`, "_blank");
        dotloopAuth(tokenState);
        break;
    case "crm":
        alert('Please contact us at matt@dealcompass.co to get access to DealCompass CRM.');
        break;
    case "google":
        googleAuth(tokenState, optionalScope);
        break;
    case "fub":
        alert('FollowUpBoss integration is currently in beta! Please contact us at matt@dealcompass.co to get early access.');
        // window.open(`https://functionappfordev.azurewebsites.net/api/fubAuthHandler?action=authCode&state=${tokenState}`, "_blank");
        break;
    case "kvcore":
        alert('KV Core integration is currently in beta! Please contact us at matt@dealcompass.co to get early access.');
        // window.open(`https://functionappfordev.azurewebsites.net/api/kvcoreAuthHandler?action=authCode&state=${tokenState}`, "_blank");
        break;
    case "graph":
        graphAuth(tokenState);
        break;
    case "zillow":
        alert('Zillow integration is currently in beta! Please contact us at matt@dealcompass.co to get early access.');
        break;
    case "trello":

    // THIS IS A FRONTEND URL NOT BACKEND 
        const redirectUrl = encodeURIComponent(`https://chat.dealcompass.co/trelloRedirect?state=${tokenState}`);
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            window.location.href = `https://trello.com/1/authorize?expiration=never&scope=read,write&response_type=token&key=${"03f523b201af8562a3c40774a291f110"}&return_url=${redirectUrl}`;
        } else {
            window.open(`https://trello.com/1/authorize?expiration=never&scope=read,write&response_type=token&key=${"03f523b201af8562a3c40774a291f110"}&return_url=${redirectUrl}`, "_blank");
        }
        break;
    default:
        console.error("Unknown API:", api);
}
}





const graphAuth = (tokenState) => {
const SP_SCOPES = [
    "offline_access",
    "openid",
    "profile",
    "User.Read",
    // "ChannelMessage.Read.All",
    // "ChannelSettings.Read.All",
    // // "ChannelMessage.Send",
    // "Chat.ReadWrite.All",
    // // "Chat.ReadWrite",
    // // "ChatMessage.Send",
    "email",
    "Files.Read.All",
    "Sites.FullControl.All",
    "Sites.Selected",
    // "Team.ReadBasic.All",
    "Mail.ReadWrite",
    "Mail.Send",
    // "TeamSettings.ReadWrite.All",
    "Calendars.ReadWrite",
    "Contacts.ReadWrite",
  ];
  
  const SP_SCOPE = encodeURIComponent(SP_SCOPES.join(" "));
//   const SP_CLIENT_ID = "cdd07fb3-50e9-4529-9486-fe3a4a9c5ee0"; // for DealCompass directory
    const SP_CLIENT_ID = "3209b84b-4936-40e9-a097-e79b5d59395b"
  const SP_REDIRECT_URI = `https://functionappfordev.azurewebsites.net/api/GraphOAuth2Callback`;

            
    const SP_AUTHORIZATION_URL = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${SP_CLIENT_ID}&response_type=code&response_mode=query&redirect_uri=${encodeURI(SP_REDIRECT_URI)}&scope=${SP_SCOPE}&state=${tokenState}`;


    const authUrl = SP_AUTHORIZATION_URL;
    const width = 600;
    const height = 600;
    const left = (window.outerWidth - width) / 2;
    const top = (window.outerHeight - height) / 2;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
        window.location.href = authUrl; // Navigate current tab
    } else {
        window.open(authUrl, 'authPopup', `width=${width},height=${height},top=${top},left=${left}`);
    }
}



const googleAuth = (tokenState, optionalScope) => {
const SP_SCOPES = [
    "openid",
    "email",
    "profile",
    "https://www.googleapis.com/auth/calendar",
    // "https://www.googleapis.com/auth/gmail.modify",
    "https://www.googleapis.com/auth/gmail.send",
    // "https://www.googleapis.com/auth/gmail.settings.basic",
    "https://www.googleapis.com/auth/userinfo.profile",
    "https://www.googleapis.com/auth/drive.file"
  ];

//   if (optionalScope === "gmail") {
//     SP_SCOPES.push("https://www.googleapis.com/auth/gmail.send");
//     // SP_SCOPES.push("https://www.googleapis.com/auth/gmail.settings.basic"); // restricted scope
//     // SP_SCOPES.push("https://www.googleapis.com/auth/gmail.modify"); // restricted scope
//   } else if (optionalScope === "calendar") {
//     SP_SCOPES.push("https://www.googleapis.com/auth/calendar");
//   } else if (optionalScope === "drive") {
//     // SP_SCOPES.push("https://www.googleapis.com/auth/drive"); // restricted scope
//     SP_SCOPES.push("https://www.googleapis.com/auth/drive.file");
//   }

  const SP_SCOPE = encodeURIComponent(SP_SCOPES.join(" "));

        
//   const SP_REDIRECT_URI = optionalScope ? "https://functionappfordev.azurewebsites.net/api/GoogleOAuth2Callback" : "https://functionappfordev.azurewebsites.net/api/GoogleOAuth2Callback";
//   const SP_CLIENT_ID = optionalScope ? "778072279551-itroliubk9mr4o5naiqnlpjh71lbtoh5.apps.googleusercontent.com" : "646282280444-6hspq725m1oglopn8ft4s24pcgkemp2r.apps.googleusercontent.com"


    const SP_REDIRECT_URI = "https://functionappfordev.azurewebsites.net/api/GoogleOAuth2Callback";
  const SP_CLIENT_ID = "778072279551-itroliubk9mr4o5naiqnlpjh71lbtoh5.apps.googleusercontent.com"

  


  const SP_AUTHORIZATION_URL = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?include_granted_scopes=true&client_id=${SP_CLIENT_ID}&access_type=offline&response_type=code&ss_domain=${encodeURI(SP_REDIRECT_URI)}&prompt=consent&redirect_uri=${encodeURI(SP_REDIRECT_URI)}&scope=${SP_SCOPE}&state=${tokenState}`;



  const authUrl = SP_AUTHORIZATION_URL;
  const width = 600;
  const height = 600;
  const left = (window.outerWidth - width) / 2;
  const top = (window.outerHeight - height) / 2;


  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
    window.location.href = authUrl; // Navigate current tab
    } else {
    window.open(authUrl, 'authPopup', `width=${width},height=${height},top=${top},left=${left}`);
    }

//   window.open(authUrl, 'authPopup', `width=${width},height=${height},top=${top},left=${left}`);
}



const dotloopAuth = (tokenState) => {

const clientId = '95127577-3cb1-4f02-b822-a37c2875c4be'
// const redirectUrl = 'https://localhost:7443/api/dotloopAuthHandler?action=POST'
const redirectUrl = 'https://functionappfordev.azurewebsites.net/api/dotloopAuthHandler?action=authCode'
const redirectOnDeny = 'false';

const authUrl = `https://auth.dotloop.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&state=${tokenState}&redirect_on_deny=${redirectOnDeny}`

const width = 600;
const height = 600;
const left = (window.outerWidth - width) / 2;
const top = (window.outerHeight - height) / 2;


const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    window.location.href = authUrl; // Navigate current tab
  } else {
  window.open(authUrl, 'authPopup', `width=${width},height=${height},top=${top},left=${left}`);
  }

}



// function generateUsername() {
//     const adjectives = [
//       "Anonymous", "Curious", "Sleepy", "Happy", "Brave", "Shy", "Clever", "Witty",
//       "Sneaky", "Fuzzy", "Boring", "Hungry", "Lucky", "Noisy", "Odd", "Quick"
//     ];
    
//     const animals = [
//       "Walrus", "Fox", "Penguin", "Koala", "Otter", "Llama", "Bear", "Sloth",
//       "Raccoon", "Tiger", "Cat", "Dog", "Panda", "Moose", "Hawk", "Turtle"
//     ];
    
//     const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
//     const animal = animals[Math.floor(Math.random() * animals.length)];
//     const number = Math.floor(Math.random() * 1000); // optional number suffix
    
//     return `${adjective}${animal}${number}`;
//     }
    